var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-container"},[_c('div',{staticClass:"layout-canvas-wrap"},[_c('div',{staticClass:"layout-canvas"},[_c('router-view')],1)]),_vm._v(" "),_c('partials-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }